import AlphaFilters from '@nematis/wp-alpha/assets/js/abstracts/classes/alpha-filters'

AlphaFilters.addFilter('module.headerStates.useHoverClass', () => false, 'child/header')
